module.exports = __webpack_public_path__ + "./MaoChun_a06b8a3f502f1f03244be4da26f76e1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/MaoChun.jpg
// module id = 568
// module chunks = 0